export default __webpack_public_path__ + "static/media/key-horizontal-unlocked.5da9dbb5.svg";